<template>
    <v-card class="mb-4">
        <v-card-title class="text-h6 mt-2">
            <h4 class="mb-0">
                <strong> Puesto de empaquetado</strong>
            </h4>
        </v-card-title>


        <v-card-text class="pa-0">
            <div class="d-flex pa-3">
                    <div class="text-h6 pl-1 text-grey-600 mb-3">
                        {{ currentLocation || 'No definida' }}
                    </div> 
                    <v-btn color="blue-grey" variant="outlined" size="small" class="ml-4 mt-1" @click="$emit('change-location')">
                        <v-icon start>mdi-pencil</v-icon>
                        Cambiar
                    </v-btn>

            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "CurrentLocationCard",
    props: {
        currentLocation: {
            type: Object,
            default: null
        }
    },
    emits: ['change-location'],
    computed: {
        locationDetails() {
            if (!this.currentLocation) return null;
            return this.currentLocation;
        }
    }
};
</script>

<style scoped>
.bg-blue-lighten-5 {
    background-color: #E3F2FD !important;
}
</style>
